
import { app } from '../app.js';
import {auth} from '../../App';
import Divider from '@mui/material/Divider';
import dayjs from 'dayjs';
import { getUsers  } from "firebase/auth";
import { useState, useEffect } from 'react';
import { Alert, Button, FormControl, InputAdornment, TextField, Typography } from '@mui/material';
import { DateField } from '@mui/x-date-pickers';
import Grid from '@mui/material/Grid';
import { updateDocToDb, getDataCount, decacheCollection, getDataByKey } from '../../controller/firestore.js';
import { setDoc } from 'firebase/firestore';

import {  getPermission } from '../../controller/user.js';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import React from 'react';
import { ConfirmDialog } from '../../components/Confirm.js';
import ViewRecord from '../../main-component/ViewRecord.js';

import VisibilityIcon from '@mui/icons-material/Visibility';
import { Link } from 'react-router-dom';
const PagamentiCandidato = (props) => {
    //const doc=props.docData;
    const id=props.id;
    const [doc,setDoc]=useState(null);
    const user = props.user;
    const setDocChanged=props.setDocChanged;
    const [openDelDialog,setOpenDelDialog]=useState(false);
    const [curPagamentoSelected,setCurPagamentoSelected]=useState(null);
    const [guideEffettuate,setGuideEffettuate]=useState(0);
    const delButtons=[
        {
          name:"delete-pagamenti-ok",
          text:"Ok",
          callback: async function () {
            setOpenDelDialog(false);
           // await deleteDocElement(collectionName,currentIdAction);
           const curPag=doc.pagamenti;
           const newArr=curPag.filter(pag => pag.id!==curPagamentoSelected);
           const esito=await updateDocToDb("candidati",null,id,{pagamenti:newArr});
           
           
           if (!esito[0]) setErrorMessage(esito[1]);
           else {
               setPagamenti(newArr);
               
               setDocChanged({...doc,pagamenti:newArr});   
               decacheCollection("candidati");
               
               setReloadPagamentiCount(reloadPagamentiCount+1);
           }
          }
        },
        {
          name:"delete-pagamenti-ko",
          text:"Annulla",
          callback: function () {
            setOpenDelDialog(false);
          }
        }
    
      ];
    
      const [lezioniPagate,setLezioniPagate]=useState(0);  
    const [pagamenti,setPagamenti]=useState(null);
    const [reloadPagamentiCount,setReloadPagamentiCount]=useState(0);
      useEffect(() => {
          
        const fetchData = async () => {
          const params = {
            "where":["id", "==", id],
            "pagination":false
          }
          
          const doc=await getDataByKey("candidati",id);
          setDoc(doc);
          if (doc && doc.pagamenti) {
            const pagamentiArr=[];
            let lezioniP=0;
                doc.pagamenti.forEach(pagDoc => {
                    
                    if (pagDoc.creation_date && typeof(pagDoc.creation_date.toDate)==="function")
                    pagDoc.creation_date=pagDoc.creation_date.toDate();
                    if (pagDoc.dataPagamento && typeof(pagDoc.dataPagamento.toDate)==="function")
                    pagDoc.dataPagamento=pagDoc.dataPagamento.toDate();
                    let pag={...pagDoc};
                    lezioniP+=pag.lezioniPagate;
                    pag.actions=[
                        <><GridActionsCellItem
                                        icon={<DeleteIcon />}
                                        label="Elimina"
                                        data-target={pag.id}
                                        onClick={(params) => onDelete(params,pag.id)}
                                        />
                                    </>
                    ];
                    pagamentiArr.push(pag);
                });
                setPagamenti(pagamentiArr);
                setLezioniPagate(lezioniP);
            }
        };
        
        if (id) fetchData();
      }, [id,reloadPagamentiCount]);
    const onDelete = React.useCallback((event,id) => {
      //  console.log("On delete pagamento");
      //  console.log(event,id);
        setCurPagamentoSelected(id);
        setOpenDelDialog(true);
        
        return false;
      }, []);

      
        const [reloadGuideCount,setReloadGuideCount]=useState(true);
        useEffect(() => {
          const fetchGuideCount = async () => {
            const activePermission=getPermission("collection","guide",null,user);
            const params={
              "permission":activePermission,        
              "user":user,
              "filters":{
                    "candidato":{type:'equalTo', value:id}
                
              }
            };
            try {
              const data = await getDataCount("guide", app.collections_config["guide"]["views"]["tableCandidato"], params);
              setGuideEffettuate(data.rowsLength);
    //          console.log("Guide count", data);
        
             // console.log("Istruttori", istruttoriMap);
             setReloadGuideCount(false);
            } catch (error) {
           //   setErrorMessageHeader("Errore");
            //  setErrorMessage("Error fetching istruttori: " + error.message);
            }
          };
          if (reloadGuideCount)
            fetchGuideCount();
        }, []);

    const delMessage="Confermi l'eliminazione del pagamento?";
    
    
    let newPag={
        creation_date:new Date()
    };
    newPag.id=new Date().toString();
    const [nuovoPagamento,setNuovoPagamento]=useState(newPag);
    const [errorMessage,setErrorMessage] =useState("");
    const headers=[
        {"field":'creation_date', headerName:'Data inserimento', width:150,type:'datetime', valueFormatter: (params) => (params.value?dayjs(params.value).format('DD/MM/YYYY HH.mm'):"") },                        
        {"field":'dataPagamento',  headerName:'Data pagamento', width:150,type:'date', valueFormatter: (params) => (params.value?dayjs(params.value).format('DD/MM/YYYY'):"") },                        
        {"field":'importoPagamento',  headerName:'Importo',valueFormatter: (params) => (params.value+" €"), width:150},
        {"field":'lezioniPagate',  headerName:'Lezioni', width:75 },
        {"field":'nota',  headerName:'Nota', width:300 },
        {"field":'actions', headerName:'Azioni', width:150, renderCell: (params) => {
            
            return (
                <strong> { params.value != null && params.value.map( (element, index) => (
                    <React.Fragment key={index}>
                    {element}
                    </React.Fragment>
                ))}
            </strong>
          )}},
                
    ]
    const changedValue = (e) => {
        
        if (e==null) 
            return;
        let value;
        const field=e.$isDayjsObject?'dataPagamento':e.target.name;
        if (e.$isDayjsObject) 
            value=e.$d;
        else {
            value=e.target.value;
            if (e.target.type==="number") value=parseInt(value);
        }
        setNuovoPagamento({...nuovoPagamento,[field]:value});
    };
    async function  handleSubmitForm(event) {
 
    
        event.preventDefault();
        
        try {
            let newArr;
            if (!doc.pagamenti) newArr=[];
            else
                newArr=doc.pagamenti;
            newArr.push(nuovoPagamento);
            const esito=await updateDocToDb("candidati",null,id,{pagamenti:newArr});
        //    console.log("Esito update/add",(esito[0]?'OK':'KO'));
            
            if (!esito[0]) setErrorMessage(esito[1]);
            else {
                setPagamenti(newArr);
                setDocChanged({...doc,pagamenti:newArr});
                decacheCollection("candidati");
                
                setReloadPagamentiCount(reloadPagamentiCount+1);
                event.target.reset();
                let newPag={
                    creation_date:new Date()
                };
                newPag.id=new Date().toString();
                setNuovoPagamento(newPag);
            }
     //     setFormClosed(esito[0]);
        } catch (error) {
            setErrorMessage(error);
        }
    }
   // console.log(id,doc);
    return (
    
    <>
        <ConfirmDialog 
         key='delPagamConfirm' 
         title='Attenzione' 
         message={delMessage} 
         buttons={delButtons} 
         onClose={delButtons[1].callback} 
         open={openDelDialog} 
         setOpen={setOpenDelDialog} 
         />
        <Divider sx={{pt:2}}  textAlign="left">Stato</Divider>
        <Typography sx={{pt:0}} gutterBottom>Numero guide registrate: {guideEffettuate}</Typography>

        <Typography sx={{pt:0, color: lezioniPagate < guideEffettuate ? 'red' : 'inherit' }} gutterBottom>Numero guide Saldate: {lezioniPagate}</Typography>

        <Divider sx={{pt:2}}  textAlign="left">Registra pagamento</Divider>
        {errorMessage!=="" && <Alert severity="error">{errorMessage}</Alert> }
        <form onSubmit={handleSubmitForm}>
            <Grid sx={{pt:2, pb:2}} container spacing={3}>
            
                <Grid item key="dataPagamento">
                    <FormControl fullWidth><DateField  onChange={changedValue} variant="outlined" label="Data pagamento"  required={true} id="dataPagamento" name="dataPagamento" /></FormControl>
                </Grid>
                <Grid item key="importoPagamento">
                    <TextField fullWidth variant="outlined" InputProps={{
            startAdornment: <InputAdornment position="start">€</InputAdornment>,
          }} type="number" onChange={changedValue} required={true} id="importoPagamento" name="importoPagamento" label="Importo"  />
                </Grid>
                <Grid item key="lezioniPagate">
                    <TextField fullWidth variant="outlined" type="number" onChange={changedValue} required={true} id="lezioniPagate" name="lezioniPagate" label="Lezioni pagate"  />
                </Grid>
                <Grid item key="Nota">
                    <TextField fullWidth variant="outlined" onChange={changedValue} id="nota" name="nota" label="Nota"  />
                </Grid>
                
                <Grid item key="submit">
                    
                     <Button type="submit" color="success" variant="contained">Registra</Button>
                </Grid>
            </Grid>
        </form>
        <Divider sx={{pt:2, pb:2} } textAlign="left">Storico pagamenti</Divider>    
        <div>
        {doc && doc.pagamenti && doc.pagamenti.length>0 ?
          <DataGrid 
              rows={ pagamenti}
              columns={headers}
              
              
          /> : <Typography sx={{pt:0}} gutterBottom>Nessun pagamento registrato</Typography>}
        </div>
    </>
    )
    ;
}
const GuideCandidato = (props) => {
    const doc=props.docData;
    const candidatoId=props.id;
    const user=props.user;
    const collectionName="guide";
    const filters={
        "guide":{
            "candidato":{type:'equalTo', value:candidatoId}
        }
    };
    const viewCfg="tableCandidato";
    const paramsObj={
        "actions":[
            /*{



                
                "name":"viewButtonCustom",
                "render":<Link to={`/viewGuida/%id%`} state={{ data: { id: "%id%", docData: "%docData%" } }}>
                    <GridActionsCellItem icon={<VisibilityIcon />} label="Visualizza" />
                </Link>/Link>
            },*/
         /*   {
                label: "Visualizza Singola Guida",
                icon: <VisibilityIcon />,
               // dataTarget:record.id,
                actionToDo: "link",  // Può essere "link" o "function"
                link:"viewGuida/%id%"
            }*/
        ]
    }
    return (<ViewRecord 
        user={user}
        filters ={filters}
        collectionName={collectionName}
        view = {viewCfg}
        params= {paramsObj}
        ></ViewRecord>
    
    );
}

const EsamiCandidato = (props) => {
    
    const id=props.id;
    const [doc,setDoc]=useState(null);
    //console.log("EsamiCandidato",doc);
    const user = props.user;
    const setDocChanged=props.setDocChanged;
    const [openDelDialog,setOpenDelDialog]=useState(false);
    const [curEsameSelected,setCurEsameSelected]=useState(null);
    const [guideEffettuate,setGuideEffettuate]=useState(0);
    
    const [esami,setEsami]=useState(null);
    const delButtons=[
        {
          name:"delete-esami-ok",
          text:"Ok",
          callback: async function () {
            setOpenDelDialog(false);
           // await deleteDocElement(collectionName,currentIdAction);
           const curEsame=doc.esami;
           const newArr=curEsame.filter(esame => esame.id!==curEsameSelected);
           const esito=await updateDocToDb("candidati",null,id,{esami:newArr});
           
           
           if (!esito[0]) setErrorMessage(esito[1]);
           else {
               setEsami(newArr);
               
               //setDocChanged({...doc,esami:newArr});               
               decacheCollection("candidati");
               
               setEsamiReloadCount(esamiReloadCount+1);
           }
          }
        },
        {
          name:"delete-esami-ko",
          text:"Annulla",
          callback: function () {
            setOpenDelDialog(false);
          }
        }
    
      ];
      const [esamiReloadCount,setEsamiReloadCount]=useState(0);
      useEffect(() => {
          
          const fetchData = async () => {
            const params = {
              "where":["id", "==", id],
              "pagination":false
            }
            
            const doc=await getDataByKey("candidati",id);
            setDoc(doc);
            if (doc && doc.esami) {
                const esamiArr=[];
                doc.esami.forEach(esameDoc => {
                    
                   /* if (esameDoc.date && typeof(esameDoc.date.toDate)==="function")
                        esameDoc.date=esameDoc.date.toDate();
                    else {
                        const timestamp = esameDoc.date.seconds * 1000; // Converti in millisecondi
                        esameDoc.date = new Date(timestamp);
        
                        //const esameDoc.date = date.toISOString().split('T')[0];
                    }*/
                    let esame={...esameDoc};
                    esame.actions=[
                        <><GridActionsCellItem
                                        icon={<DeleteIcon />}
                                        label="Elimina"
                                        data-target={esame.id}
                                        onClick={(params) => onDelete(params,esame.id)}
                                        />
                                    </>
                    ];
                    esamiArr.push(esame);
                });
                setEsami(esamiArr);
            }
          };
          
          if (id) fetchData();
        }, [id,esamiReloadCount]);
    const onDelete = React.useCallback((event,id) => {
      //  console.log("On delete esame");
      //  console.log(event,id);
        setCurEsameSelected(id);
        setOpenDelDialog(true);
        
        return false;
      }, []);

      
       

    const delMessage="Confermi l'eliminazione dell'esame?";
    
    
    
    let newEsame={
        date:new Date()
    };
    newEsame.id=new Date().toString();
    const [nuovoEsame,setNuovoEsame]=useState(newEsame);
    const [errorMessage,setErrorMessage] =useState("");
    const headers=[
        {"field":'date', headerName:'Data esame', width:150,type:'date', valueFormatter: (params) => (params.value?dayjs(params.value).format('DD/MM/YYYY'):"") },                        
        {"field":'esito',  headerName:'Esito', width:150},
        {"field":'nota',  headerName:'Nota', width:300 },
        {"field":'actions', headerName:'Azioni', width:150, renderCell: (params) => {
            
            return (
                <strong> { params.value != null && params.value.map( (element, index) => (
                    <React.Fragment key={index}>
                    {element}
                    </React.Fragment>
                ))}
            </strong>
          )}},
                
    ]
    const changedValue = (e) => {
        
        if (e==null) 
            return;
        let value;
        const field=e.$isDayjsObject?'date':e.target.name;
        if (e.$isDayjsObject) 
            value=e.format("YYYY-MM-DD");
        else {
            value=e.target.value;
            if (e.target.type==="number") value=parseInt(value);
        }
        setNuovoEsame({...nuovoEsame,[field]:value});
    };
    async function  handleSubmitForm(event) {
 
    
        event.preventDefault();
        
        try {
            let newArr;
            if (!doc.esami) newArr=[];
            else
                newArr=doc.esami;
            newArr.push(nuovoEsame);
            const esito=await updateDocToDb("candidati",null,id,{esami:newArr});
          //  console.log("Esito update/add",(esito[0]?'OK':'KO'));
            
            if (!esito[0]) setErrorMessage(esito[1]);
            else {
                setEsami(newArr);
              //  setDocChanged({...doc,esami:newArr});
                decacheCollection("candidati");
                
                setEsamiReloadCount(esamiReloadCount+1);
                event.target.reset();
                let newEsame={
                    date:new Date()
                };
                newEsame.id=new Date().toString();
                setNuovoEsame(newEsame);
            }
     //     setFormClosed(esito[0]);
        } catch (error) {
            setErrorMessage(error);
        }
    }
  //  console.log(id,doc);
    return (
    
    <>
        <ConfirmDialog 
         key='delEsameConfirm' 
         title='Attenzione' 
         message={delMessage} 
         buttons={delButtons} 
         onClose={delButtons[1].callback} 
         open={openDelDialog} 
         setOpen={setOpenDelDialog} 
         />

        <Divider sx={{pt:2}}  textAlign="left">Registra esame</Divider>
        {errorMessage!=="" && <Alert severity="error">{errorMessage}</Alert> }
        <form onSubmit={handleSubmitForm}>
            <Grid sx={{pt:2, pb:2}} container spacing={3}>
            
                <Grid item key="date">
                    <FormControl fullWidth><DateField  onChange={changedValue} variant="outlined" label="Data esame"  required={true} id="date" name="date" /></FormControl>
                </Grid>
                <Grid item key="esito">
                <FormControl fullWidth>
                            <TextField
                                select
                                variant="outlined"
                                onChange={changedValue}
                                required={true}
                                id="esito"
                                name="esito"
                                label="Esito"
                                defaultValue=""
                                SelectProps={{
                                    native: true,
                                }}
                            >
                                <option value="" disabled></option>
                                <option value="POSITIVO">POSITIVO</option>
                                <option value="NEGATIVO">NEGATIVO</option>
                            </TextField>
                        </FormControl>
                </Grid>
                <Grid item key="Nota">
                    <TextField fullWidth variant="outlined" onChange={changedValue} id="nota" name="nota" label="Nota"  />
                </Grid>
                
                <Grid item key="submit">
                    
                     <Button type="submit" color="success" variant="contained">Registra</Button>
                </Grid>
            </Grid>
        </form>
        <Divider sx={{pt:2, pb:2} } textAlign="left">Storico esami</Divider>    
        <div>
        {doc && doc.esami && doc.esami.length>0 ?
          <DataGrid 
              rows={ esami}
              columns={headers}
              
              
          /> : <Typography sx={{pt:0}} gutterBottom>Nessun esame registrato</Typography>}
        </div>
    </>
    )
    ;
}
const obj={
    "singleLabel":"Candidato",
    "label":"Candidati",
    "orderBy":"cognomeLower",
    "views":{
        "table":{           
            "autoLoad":false,
            "filter":true,
            //"defaultTab":"filter",
            "defaultTab":1,   
            "fieldList":[
                {"field":'id', headerName:'ID', width:70 },                
     //           {"field":'creation_date', headerName:'Data creazione', width:150,type:'datetime', valueFormatter: (params) => (params.value?dayjs(params.value).format('DD/MM/YYYY HH.mm'):""),  filter:{type:"datetime",gridProp:{xs:12} } },                        
                {"field":'fogliorosa_date', headerName:'Rilascio foglio rosa', width:150,type:'date', valueFormatter: (params) => (params.value?dayjs(params.value).format('DD/MM/YYYY'):""), filter:{type:"date",gridProp:{xs:12} } },                        
                {"field":'cognome', headerName:'Cognome', width:150,filter:{gridProp:{xs:12},"targetField":"cognomeLower", "trasformations":[{"type":"valueFunction","function":"toLowerCase"}]}},
                {"field":'nome', headerName:'Nome', width:150,filter:{gridProp:{xs:12},"targetField":"nomeLower", "trasformations":[{"type":"valueFunction","function":"toLowerCase"}] } },
                {"field":'stato', headerName:'Stato', width:150, filter:{type:"select", options:[{value:1,label:"Attivo"}, {value:2,label:"Concluso"}, {value:0,label:"Non attivo"} ], gridProp:{xs:12} }, valueGetter:(params)=> {
                    const options={1:"Attivo", 2:"Concluso",0:"Non attivo"} ;
                    if (!options[params.value]) return "Non impostato";
                    return options[params.value];
                } },
                {"field":'categoria', headerName:'Categoria', filter:{gridProp:{xs:12},type:"select",options:[{value:"a",label:"A"}, {value:"b",label:"B"}, {value:"bauto",label:"B AUTO"}, {value:"be",label:"B+E"}, {value:"c",label:"C"}, {value:"ce",label:"C+E"}, {value:"d",label:"D"}, {value:"de",label:"D+E"} ]  }, width:150, valueGetter:(params)=> {
                    const options={"a":"A", "b":"B", "bauto":"B AUTO", "be":"B+E", "c":"C", "ce":"C+E", "d":"D", "de":"D+E"} ;
                    if (!options[params.value]) return "Non impostato";
                    return options[params.value];
                } },
        //        {"field":'telefono', headerName:'Telefono', width:150 },
        //        {"field":'email', headerName:'Email', width:150 },
                
            ], 
            "initialState":{
                columns: {
                    columnVisibilityModel: {
                        id:false
                    }
                }
            }
        },
        "tableSimple":{           
            "autoLoad":false,
            "filter":true,
            //"defaultTab":"filter",
            "defaultTab":1,   
            "fieldList":[
                {"field":'id', headerName:'ID', width:70 },                
     //           {"field":'creation_date', headerName:'Data creazione', width:150,type:'datetime', valueFormatter: (params) => (params.value?dayjs(params.value).format('DD/MM/YYYY HH.mm'):""),  filter:{type:"datetime",gridProp:{xs:12} } },                        
                {"field":'fogliorosa_date', headerName:'Rilascio foglio rosa', width:150,type:'date', valueFormatter: (params) => (params.value?dayjs(params.value).format('DD/MM/YYYY'):""), filter:{type:"date",gridProp:{xs:12} } },                        
                {"field":'cognome', headerName:'Cognome', width:150,filter:{gridProp:{xs:12},"targetField":"cognomeLower", "trasformations":[{"type":"valueFunction","function":"toLowerCase"}]}},
                {"field":'nome', headerName:'Nome', width:150,filter:{gridProp:{xs:12},"targetField":"nomeLower", "trasformations":[{"type":"valueFunction","function":"toLowerCase"}] } },
               
                {"field":'categoria', headerName:'Categoria', filter:{gridProp:{xs:12},type:"select",options:[{value:"a",label:"A"}, {value:"b",label:"B"}, {value:"bauto",label:"B AUTO"}, {value:"be",label:"B+E"}, {value:"c",label:"C"}, {value:"ce",label:"C+E"}, {value:"d",label:"D"}, {value:"de",label:"D+E"} ]  }, width:150, valueGetter:(params)=> {
                    const options={"a":"A", "b":"B", "bauto":"B AUTO", "be":"B+E", "c":"C", "ce":"C+E", "d":"D", "de":"D+E"} ;
                    if (!options[params.value]) return "Non impostato";
                    return options[params.value];
                } },
                
            ], 
            "initialState":{
                columns: {
                    columnVisibilityModel: {
                        id:false
                    }
                }
            }
        },
        "view":{              
            "fieldList":[
                
                                      
                {"field":'creation_date', headerName:'Data creazione', showOnNew:true,  type:'datetime',gridProp:{xs:12,sm:12}, default_function:"getCreationDatetime", textProps:{ InputProps:{readOnly: true},  disabled:true} },
                {"field":'cognome', headerName:'Cognome', gridProp:{xs:12,sm:6}, required:true},                
                {"field":'nome', headerName:'Nome', gridProp:{xs:12,sm:6} , required:true},
                {"field":'stato', headerName:'Stato', type:'select', options:[{value:1,label:"Attivo"}, {value:2,label:"Concluso"}, {value:0,label:"Non attivo"} ] , gridProp:{xs:12,sm:6}, default:0 , required:true},
                {"field":'categoria', headerName:'Categoria', type:'select', options:[{value:"a",label:"A"}, {value:"b",label:"B"}, {value:"bauto",label:"B AUTO"}, {value:"be",label:"B+E"}, {value:"c",label:"C"}, {value:"ce",label:"C+E"}, {value:"d",label:"D"}, {value:"de",label:"D+E"} ] , gridProp:{xs:12,sm:6}, required:true},
                {"field":'fogliorosa_date', headerName:'Rilascio foglio rosa', showOnNew:true,  type:'date',gridProp:{xs:12,sm:6} },
                {"field":'fogliorosa_scadenza', headerName:'Scadenza foglio rosa', showOnNew:true,  type:'date',gridProp:{xs:12,sm:6} },
                {"field":'telefono', headerName:'Telefono', gridProp:{xs:12,sm:6} , required:true},
                {"field":'email', headerName:'Email', gridProp:{xs:12,sm:6} , required:false},
            ], 
            
            "addingTabs":[
                {
                    "key":"pagamentiCandidato",
                    "label":"Pagamenti",
                    "Component":PagamentiCandidato,
                    "props":{
                        "body":""
                    }
                }, {
                    "key":"esamiCandidato",
                    "label":"Esami",
                    "Component":EsamiCandidato,
                    "props":{
                        "body":""
                    }
                },
                {
                    "key":"guideCandidato",
                    "label":"Guide",
                    "Component":GuideCandidato,
                    "props":{
                        "body":""
                    }
                },
            ],
        },
        "update":{              
            "fieldList":[
                
                                      
                {"field":'creation_date', headerName:'Data creazione', showOnNew:true,  type:'datetime',gridProp:{xs:12,sm:12}, default_function:"getCreationDatetime", textProps:{ InputProps:{readOnly: true},  disabled:true} },
                {"field":'cognome', headerName:'Cognome', gridProp:{xs:12,sm:6}, required:true},                
                {"field":'nome', headerName:'Nome', gridProp:{xs:12,sm:6} , required:true},
                {"field":'stato', headerName:'Stato', type:'select', options:[{value:1,label:"Attivo"}, {value:2,label:"Concluso"}, {value:0,label:"Non attivo"} ] , gridProp:{xs:12,sm:6}, default:0 , required:true},
                {"field":'categoria', headerName:'Categoria', type:'select', options:[{value:"a",label:"A"}, {value:"b",label:"B"}, {value:"bauto",label:"B AUTO"}, {value:"be",label:"B+E"}, {value:"c",label:"C"}, {value:"ce",label:"C+E"}, {value:"d",label:"D"}, {value:"de",label:"D+E"} ]  , gridProp:{xs:12,sm:6}, required:true},
                {"field":'fogliorosa_date', headerName:'Rilascio foglio rosa', showOnNew:true,  type:'date',gridProp:{xs:12,sm:6}, onSet:{
                    "computedFields":[
                        {"field":'fogliorosa_scadenza_actualYear', "source":"fogliorosa_date", "type":"valueFunction","function":"getFullYear" },
                        {"field":'fogliorosa_dateCopied', "source":{"type":"fixed","value":"obj['fogliorosa_date']"}, "type":"eval","function":"new Date(%1%); " },
                        {"field":'fogliorosa_scadenza1', "source":[{"type":"fixed","value":"obj['fogliorosa_dateCopied']"},"fogliorosa_scadenza_actualYear"], "type":"eval","function":"%1%.setFullYear(%2% + 1)"},
                        {"field":'fogliorosa_scadenza', "source":{"type":"fixed","value":"obj['fogliorosa_dateCopied']"}, "type":"eval","function":"%1%"}
                        
                    ]
                } },
                {"field":'fogliorosa_scadenza', headerName:'Scadenza foglio rosa', showOnNew:true,  type:'date',gridProp:{xs:12,sm:6} },
                {"field":'telefono', headerName:'Telefono', gridProp:{xs:12,sm:6} , required:true},
                {"field":'email', headerName:'Email', gridProp:{xs:12,sm:6} , required:false},
            ], 
            
            "computedFields":[
                {"field":'cognomeLower', "source":"cognome", "type":"valueFunction", "function":"toLowerCase"},                
                {"field":'nomeLower', "source":"nome", "type":"valueFunction","function":"toLowerCase"}
                

            ],
        }
    }
};
app.collections_config["candidati"]=obj;
export {GuideCandidato, EsamiCandidato}